import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { TranslateModule } from '@ngx-translate/core'

import { AppointmentDetailsFactComponent } from './appointment-details-fact.component'

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslateModule,
  ],
  exports: [
    AppointmentDetailsFactComponent,
  ],
  declarations: [
    AppointmentDetailsFactComponent,
  ],
  providers: [],
})
export class AppointmentDetailsFactModule { }
